module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("alert alert-danger alert-vanguard text-center " + _vm.className),
    style: (("top: " + _vm.top))
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf68b99","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/alert.vue
// module id = 633
// module chunks = 0 1 2 3